import React from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import DownloadWhiteIcon from '../assets/icons/JSX/DownloadWhiteIcon'
import Responsive from '../assets/config/Responsive'

const DownloadButton: React.FC<{
  onClick?: (_: any) => void
  style?: React.CSSProperties
  text?: string
}> = ({ onClick, style, text }) => {
  return (
    <Btn style={style} type="button" onClick={onClick}>
      {text ? <span style={{ marginRight: -10, marginTop: 5 }}>{text}</span> : null}
      <DownloadWhiteIcon />
    </Btn>
  )
}
//
//
const Btn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${Colors.primaryBlack};
  border-radius: 4px;
  background-color: transparent;
  padding: unset;
  height: 48px;
  width: 48px;
  min-width: 20px;
  transition: all 200ms ease-in-out;
  margin-left: 10px;
  span {
    color: ${Colors.primaryBlack};
    -webkit-text-fill-color: rgba(0, 0, 0, 1);
    -webkit-opacity: 1;
  }
  svg {
    height: 48px;
    width: 48px;
  }
  ${Responsive.mobile} {
    width: 54px;
    svg {
      width: 54px;
    }
  }

  /* hover styles */
  &:hover {
    transition: all 200ms ease-in-out;
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    g path {
      fill: #ffffff;
    }
    ${Responsive.mobile} {
      border: 1px solid ${Colors.primaryBlack};
      background-color: transparent;
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        color: ${Colors.primaryBlack};
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      g path {
        fill: ${Colors.primaryBlack};
      }
    }
    ${Responsive.tablet} {
      border: 1px solid ${Colors.primaryBlack};
      background-color: transparent;
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        color: ${Colors.primaryBlack};
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      g path {
        fill: ${Colors.primaryBlack};
      }
    }
  }
  &:active {
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    opacity: 0.9;
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    g path {
      fill: #ffffff;
    }
  }
`

export default DownloadButton
